import { AbstractControl, ValidationErrors } from "@angular/forms";
import * as moment from "moment";

export function isValidDate(control: AbstractControl): ValidationErrors | null {
    const value = control && control.value;
    if (value && (!moment(value).isValid() || moment(value).year() < 1900)) { //validate that date is >= 1900 because the angular material datepicker allows entering dates like 1/1/123 which becomes 1/1/0123
        return {
            date: true
        };
    }

    return null;
}